import React, { createContext, useState, useEffect, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { login as apiLogin, getProfile, logout as apiLogout } from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    useEffect(() => {
        const checkAuth = async () => {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const userData = await getProfile();
                    setUser(userData);
                    setIsAuthenticated(true);
                } catch (error) {
                    <Navigate to="/login" state={{ from: location }} replace />
                    console.error('Authentication check failed:', error);
                    localStorage.removeItem('token');
                }
            }
            setLoading(false);
        };

        checkAuth();
    }, []);

    // const login = async (credentials) => {
    //     try {
    //         const { token, user } = await apiLogin(credentials);
    //         console.log(user);

    //         localStorage.setItem('token', token);
    //         setUser(user);
    //         setIsAuthenticated(true);
    //         return { success: true };
    //     } catch (error) {
    //         return { success: false, error };
    //     }
    // };
    const login = async (credentials) => {
        try {
            const response = await apiLogin(credentials);
            // Check if the API returned an error despite 200 status
            if (response.status === false) {
                return { success: false, error: response };
            }
            // console.log(response);

            // Successful login
            localStorage.setItem('token', response.token);
            setUser(response.UserData);
            setIsAuthenticated(true);
            return { success: true };
        } catch (error) {
            return {
                success: false,
                error: {
                    message: error.message || 'Login failed',
                    httpStatus: error.httpStatus || 500
                }
            };
        }
    };

    const logout = async () => {
        await apiLogout();
        localStorage.removeItem('token');
        setUser(null);
        setIsAuthenticated(false);
    };

    // return (
    //     <AuthContext.Provider
    //         value={{
    //             user,
    //             isAuthenticated,
    //             loading,
    //             login,
    //             logout,
    //         }}
    //     >
    //         {children}
    //     </AuthContext.Provider>
    // );

    return (
        <AuthContext.Provider
            value={{
                user,
                isAuthenticated,
                loading,
                login,
                logout,
            }}
        >
            {children}
        </AuthContext.Provider>
    );

};
// export const useAuth = () => useContext(AuthContext);
// export function useAuth() {
//     const context = useContext(AuthContext);
//     if (context === undefined) {
//         throw new Error('useAuth must be used within an AuthProvider');
//     }
//     return context;
// }

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};